import { memo } from 'react'
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from '@mui/material'
import ProductTableRow from './ProductTableRow'
import TableLoadingRow from '../shared/TableLoadingRow'
import TableEmptyState from '../shared/TableEmptyState'

function ProductTable({
  products,
  loading,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  onView,
  onEdit,
  onDelete,
  onInventory,
  onCopySku,
  onNavigateToProduct,
}) {
  return (
    <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#f8f9fb' }}>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a', width: '80px' }}>Image</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>Article Code</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>Product Name</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>Brand</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>VAT %</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>DSD</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>TP/MAP</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>Category</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }} align="center">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableLoadingRow colSpan={10} />
            ) : products.length === 0 ? (
              <TableEmptyState colSpan={10} message="No products found" />
            ) : (
              products.map((product) => (
                <ProductTableRow
                  key={product.id}
                  product={product}
                  onView={onView}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onInventory={onInventory}
                  onCopySku={onCopySku}
                  onNavigateToProduct={onNavigateToProduct}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </Card>
  )
}

export default memo(ProductTable)
